import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function feedbacksReducer(state = initialState.feedbacks, action) {
  let newState;
  let feedbacks;
  switch (action.type) {
  case types.FEEDBACKS_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.count = action.header.count;
    newState.total = action.header.total;
    newState.feedbackList = action.payload;

    return newState;
  case types.FEEDBACKS_EXPORT_FAILURE:
  case types.FEEDBACKS_ATTACHMENT_FAILURE:
  case types.FEEDBACKS_FAILURE:
  case types.CATEGORIES_FAILURE:
  case types.REACTION_SAVE_FAILURE:
  case types.REACTION_DELETE_FAILURE:
  case types.FEEDBACK_DELETE_FAILURE:
  case types.CHANGE_CATEGORY_FAILURE:
  case types.FEEDBACK_SEND_FAILURE:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.error = action.payload.toString();
    return newState;
  case types.FEEDBACKS_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    newState.page = action.feedbacks.page;
    newState.paging = action.feedbacks.paging;
    newState.sortBy = action.feedbacks.sortBy;
    newState.sortDirection = action.feedbacks.sortDirection;
    newState.filter = action.feedbacks.filter;
    newState.selectedCategories = action.feedbacks.categories;
    newState.dateFrom = action.feedbacks.dateFrom;
    newState.dateTo = action.feedbacks.dateTo;
    newState.withComment = action.feedbacks.withComment;
    newState.withReaction = action.feedbacks.withReaction;
    newState.rating = action.feedbacks.rating;
    newState.country = action.feedbacks.country;
    newState.createdBySkodaEmployee = action.feedbacks.createdBySkodaEmployee;

    return newState;
  case types.FEEDBACKS_EXPORT_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    newState.sortBy = action.feedbacks.sortBy;
    newState.sortDirection = action.feedbacks.sortDirection;
    newState.filter = action.feedbacks.filter;
    newState.selectedCategories = action.feedbacks.categories;
    newState.dateFrom = action.feedbacks.dateFrom;
    newState.dateTo = action.feedbacks.dateTo;
    newState.withComment = action.feedbacks.withComment;
    newState.withReaction = action.feedbacks.withReaction;
    newState.rating = action.feedbacks.rating;
    newState.country = action.feedbacks.country;
    newState.createdBySkodaEmployee = action.feedbacks.createdBySkodaEmployee;

    return newState;
  case types.FEEDBACKS_EXPORT_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.file = action.payload;

    return newState;
  case types.FEEDBACKS_EXPORT_RESET:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.file = null;
    newState.attachment = null;

    return newState;
  case types.FEEDBACKS_ATTACHMENT_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';
    newState.attachment = action.attachment.name;

    return newState;
  case types.FEEDBACKS_ATTACHMENT_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.file = action.payload;

    return newState;
  case types.FEEDBACKS_ATTACHMENT_RESET:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.file = null;
    newState.attachment = null;

    return newState;
  case types.REACTION_SAVE_REQUEST:
  case types.REACTION_DELETE_REQUEST:
  case types.FEEDBACK_DELETE_REQUEST:
    newState = objectAssign({}, state);
    newState.loading = true;
    newState.error = '';

    return newState;
  case types.REACTION_SAVE_SUCCESS:
    feedbacks = [];
    state.feedbackList.forEach(feedback => {
      let f = objectAssign({}, feedback);
      if (feedback.id === action.payload.id) {
        f.adminReaction = action.payload.value;
      }
      feedbacks.push(f);
    });

    newState = objectAssign({}, state);
    newState.feedbackList = feedbacks;
    newState.loading = false;
    newState.error = '';

    return newState;
  case types.REACTION_DELETE_SUCCESS:
    feedbacks = [];
    state.feedbackList.forEach(feedback => {
      let f = objectAssign({}, feedback);
      if (feedback.id === action.payload) {
        f.adminReaction = '';
      }
      feedbacks.push(f);
    });

    newState = objectAssign({}, state);
    newState.feedbackList = feedbacks;
    newState.loading = false;
    newState.error = '';

    return newState;
  case types.FEEDBACK_DELETE_SUCCESS:
    feedbacks = [];
    state.feedbackList.forEach(feedback => {
      let f = objectAssign({}, feedback);
      if (feedback.id !== action.payload) {
        feedbacks.push(f);
      }
    });

    newState = objectAssign({}, state);
    newState.feedbackList = feedbacks;
    newState.loading = false;
    newState.error = '';

    return newState;
  case types.CATEGORIES_LOADING:
    newState = objectAssign({}, state);
    newState.loading = true;

    return newState;
  case types.CATEGORIES_SUCCESS:
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.categories = action.payload;

    return newState;
  case types.CHANGE_CATEGORY_REQUEST:
    newState = objectAssign({}, state);
    newState.loading = true;

    return newState;
  case types.CHANGE_CATEGORY_SUCCESS:
    feedbacks = [];
    state.feedbackList.forEach(feedback => {
      let f = objectAssign({}, feedback);
      if (feedback.id === action.payload.id) {
        f.categoryCode = action.payload.value;
      }
      feedbacks.push(f);
    });

    newState = objectAssign({}, state);
    newState.loading = false;
    newState.feedbackList = feedbacks;

    return newState;
  case types.FEEDBACK_SEND_REQUEST:
    newState = objectAssign({}, state);
    newState.loading = true;

    return newState;
  case types.FEEDBACK_SEND_SUCCESS:
    feedbacks = [];
    state.feedbackList.forEach(feedback => {
      let f = objectAssign({}, feedback);
      if (feedback.id === action.payload) {
        let s = objectAssign({}, feedback.feedbackStatus);
        s.type = 'sent';
        f.feedbackStatus = s;
      }
      feedbacks.push(f);
    });
    newState = objectAssign({}, state);
    newState.loading = false;
    newState.feedbackList = feedbacks;
    return newState;
  default:
    return state;
  }
}
